// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-1f10337a]{cursor:pointer;display:flex;align-items:center;position:absolute;top:.5rem;right:1rem}@media (min-width:768px){.content:hover .text[data-v-1f10337a]{color:#433eff}.content[data-v-1f10337a]:hover path{fill:#433eff}}.content:active .text[data-v-1f10337a]{color:#433eff}.content[data-v-1f10337a]:active path{fill:#433eff}.text[data-v-1f10337a]{color:#79789a;font-size:12px}", ""]);
// Exports
module.exports = exports;
